import { create } from "zustand";
import { devtools } from "zustand/middleware";
import produce from "immer";

export const useSortingData = create(
    devtools((set) => ({
        sortByName: "asc",
        sortByDate: "asc",
        setSortByName: (sortKey) => {
            return set(
                produce((state) => {
                    state.sortByName = sortKey;
                })
            );
        },
        setSortByDate: (sortKey) => {
            return set(
                produce((state) => {
                    state.sortByDate = sortKey;
                })
            );
        },
        reset: () => {
            return set(
                produce((state) => {
                    state.sortByName = "asc";
                    state.sortByDate = "asc";
                })
            );
        },
    }))
);
